import UsersService from "../services/users.sevice";

const state = {
	users: [],
	total: 0,
	singleUser: {},
	permittedObj: {},
	newUser: null,
	userDeleted: null,
	notAllowedError: false,
	hasPasswordError: false,
	passwordErrorMessage: '',
	deleteUserErrorMessage: '',
	myDepartments: {},
	userExistError: false,
	createUserErrorMessage: '',
	statusText: '',
	statusResSuccess: false
};

const getters = {
	users: (state) => {
		return state.users
	},
	getSingeuser: (state) => {
		return state.singleUser;
	},
	total: (state) => {
		return state.total;
	},
	permittedDepIds: (state) => {
		return state.permittedObj.permittedDepartmentIds;
	},
	myDeps: (state) => {
		return state.myDepartments;
	},
	permittedTransferIds: (state) => {
		return state.permittedObj.transferPermittedDepartmentIds;
	},
	deleteResponseSuccess: (state) => {
		if (state.statusText == 'OK') {
			return state.statusText = 'Фойдаланувчи ўчирилди';
		}
	},
}


const actions = {
	async fetchUsers({commit}, paramsForUsers) {
		try {
			const users = await UsersService.getUsers(paramsForUsers);
			commit('setUsers', users.data);
			return true
		} catch (e) {
			return false
		}
	},
	async createUserStore({commit}, newUserData) {
		try {
			const useradd = await UsersService.createUser(newUserData);
			commit('newUser', useradd.data);
			return true
		} catch (e) {
			let response = JSON.parse(e.request.response);
			commit('createUserError', {message: response.message, boolean: true});
			return false
		}
	},
	async deleteUserStore({commit}, id) {
		try {
			const deleteResponse = await UsersService.deleteUser(id)
			commit('deleteUser', {deleteResponse, id}),
				commit('deleteSuccess', {deleteResponse, id, boolean: true})
			return true;
		} catch (e) {
			let response = JSON.parse(e.request.response);
			commit('deleteUserError', {message: response.message, boolean: true});
			return false;
		}
	},

	async getUserStoreById({commit}, userId) {
		try {
			if (this.ability.can('get', 'user')) {
				const getUserResponse = await UsersService.getUserById(userId);
				commit('setSingleUser', getUserResponse.data);
				return true;
			}
		} catch (e) {
			return false;
		}
	},
	async getPermittedDepartments({commit}, userId) {
		try {
			const getDepartmentsResponse = await UsersService.getPermittedDepartmentsById(userId);
			commit('setPermittedDeps', getDepartmentsResponse.data);
			return true;
		} catch (e) {
			return false;
		}
	},
	async getMyDepartments({commit}) {
			try {
				const getDepartmentsResponse = await UsersService.getPermittedDepartments();
				commit('setMyDeps', getDepartmentsResponse.data);
				return true;
			} catch (e) {
				return false;
			}

	},
	async postPermittedDepartments({commit}, idAndPayload) {
		try {
			const postDepartmentsResponse = await UsersService.postPermittedDepartmentsById(idAndPayload);
			commit('setPermittedDepsResponse', postDepartmentsResponse.data);
			return true;
		} catch (e) {
			return false;
		}
	},

	async updateUserBy({commit}, payload) {
		try {
			const updateResponse = await UsersService.updateUserById(payload);
			commit('setUserPasswordChangeError', {message: '', boolean: false})
			return true
		} catch (e) {
			let response = JSON.parse(e.request.response);
			commit('setUserPasswordChangeError', {message: response.message, boolean: true});
			return false;
		}

	},
	async updateUserSelfPass({commit}, payload) {
		try {
			const updateResponse = await UsersService.updateUserSelfPassword(payload);
			commit('setUserPasswordChangeError', {message: '', boolean: false})
		} catch (e) {
			let response = JSON.parse(e.request.response);
			commit('setUserPasswordChangeError', {message: response.message, boolean: true});
			return false;
		}

	},
	async updateUserByRoles({commit}, payload) {
		try {
			const updateUserByRoleRes = await UsersService.updateUserByRoles(payload);
			return true
		} catch (e) {
			return false
		}

	},
	async updateUserByEmployeeStore({commit}, payload) {
		try {
			const updateResEmpId = await UsersService.updateUserByEmployee(payload);
			return true
		} catch (e) {
			return false;
		}
	},

	async updateUserByContragentStore({commit}, payload) {
		try {
			const updateResCtrId = await UsersService.updateUserByContragent(payload);
			return true
		} catch (e) {
			return false;
		}
	},

	updateUserStatus({commit}, payload) {
		try {
			const updateResponse = UsersService.updateUserStatusById(payload);
			commit('userStatusResponse', updateResponse.data);
		} catch (e) {
			return false;
		}

	}
};

const mutations = {
	setUsers(state, users) {
		state.users = users.items;
		state.total = users.total;
	},
	setRoles(state, roles) {
		state.roles = roles;
	},
	newUser(state, addedUser) {
		state.newUser = addedUser;
		// state.users.push(addedUser);
	},
	setUserPasswordChangeError(state, obj) {
		state.hasPasswordError = obj.boolean;
		state.passwordErrorMessage = obj.message;
	},
	createUserError(state, payload) {
		state.userExistError = payload.boolean;
		state.createUserErrorMessage = payload.message;
	},
	setSingleUser(state, user) {
		state.singleUser = user;
	},
	setPermittedDeps(state, permittedObj) {
		state.permittedObj = permittedObj;
	},
	setMyDeps(state, data) {
		state.myDepartments = data;
	},
	setPermittedDepsResponse(state, permittedResponce) {
	},
	userStatusResponse(state, response) {
	},
	deleteUser(state, obj) {
		if (obj.deleteResponse) {
			let foundIndex = state.users.findIndex(x => x.id == obj.id);
			state.users[foundIndex].status = 'DELETED';
			state.notAllowedError = false;
		}
	},
	deleteSuccess(state, obj) {
		state.statusText = obj.deleteResponse.statusText;
		state.statusResSuccess = obj.boolean;
	},
	deleteUserError(state, payload) {
		state.notAllowedError = payload.boolean;
		state.deleteUserErrorMessage = payload.message;
	}
};

export const users = {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
}
